import { render, staticRenderFns } from "./language-picker.vue?vue&type=template&id=a130ad62"
import script from "./language-picker.vue?vue&type=script&lang=js"
export * from "./language-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/09062026_084924/resources/assets/marketplace/components/BaseButton.vue').default})
